import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./sumsub-verification-config-form.i18n";

type SumSubVerificationConfigFormProps = {
  flowLanguage: string;
  livenessVerification: boolean;
  onLivenessVerificationChange: (show: boolean) => void;
};

export function SumSubVerificationConfigForm({
  flowLanguage,
  livenessVerification,
  onLivenessVerificationChange,
}: SumSubVerificationConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="flex items-center justify-between">
      <div className="space-y-0.5">
        <Label htmlFor="show-sumsub-liveness">{t.sumsubLivenessVerification}</Label>
        <p className="text-xs text-muted-foreground">{t.sumsubLivenessVerificationDesc}</p>
      </div>
      <Switch
        id="show-sumsub-liveness"
        checked={livenessVerification}
        onCheckedChange={onLivenessVerificationChange}
      />
    </div>
  );
}
